var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.081 4.28266H15.8859V1.13921C15.5745 1.09638 14.5036 1 13.2565 1C10.6542 1 8.87161 2.6368 8.87161 5.64515V8.41379H6V11.9279H8.87161V20.7701H12.3923V11.9288H15.1478L15.5852 8.41461H12.3915V5.9936C12.3923 4.97791 12.6658 4.28266 14.081 4.28266Z",
    fill: "#FDF4F4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.a3f19423a921ae91fbdc4cd7fb50e3f7.svg";
export { ForwardRef as ReactComponent };